<script setup></script>

<template>
    <button @click="$emit('onClick')" class="btn btn-sm btn-default">
        <i class="fas fa-edit text-warning"></i>
    </button>
</template>
